// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-hjblcx-index-main_right_content-3Qs_u","table":"components-tjcx-hjblcx-index-table-1ls8s"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/hjblcx/index.css
// module id = 725
// module chunks = 0